var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"topic-button d-inline-flex",attrs:{"role":"button"},on:{"click":_vm.onComments}},[_c('v-svg',{staticClass:"m-2 topic-button__label icon",attrs:{"code":"it-comment"}}),_c('p',{staticClass:"my-auto"},[_c('b',[_vm._v(_vm._s(_vm.topicsCount))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }